import styled from 'styled-components';

export const DepartmentsWrapper = styled.div`
  margin-top: 24px;

  & > div:first-child {
    margin-bottom: 16px;
  }
`;

export const FormListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  & > div {
    margin-right: 48px;
  }
`;

export const FormItemsWrapper = styled.div`
  display: flex;

  & > div:first-child {
    display: flex;
    flex-direction: column;

    & > div:last-child {
      align-self: flex-end;
      .ant-btn {
        padding: 0;
      }
    }
  }

  ${({ isVisibleDelete }: { isVisibleDelete: boolean }) =>
    isVisibleDelete &&
    `
    & > div:last-child {
        align-self: flex-start;
        margin-top: 33px;
        margin-left: 18px;
        cursor: pointer;
    }
 `}
`;
